(function($) {


    window.b2bRegisterSubmit = function(token) {
        let $form = $("form.b2b-partner_form");


        let url = ghostpress_params.ajax_url + "&action=b2b_registration",
                data = $form.serializeArray()


        gp_ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: data,
            show_loading: true
        })
                .done((response, textStatus, jqXHR) => {

                    let success = response.success

                    if(success) {
                        $form.hide();
                        let $success = $form.siblings('.b2b-partner_form__success');
                        $success.show();
                        $("html").animate({
                            scrollTop: $success.offset().top - 100
                        }, 1000);
                    }else{
                        $("html").animate({
                            scrollTop: $(".notices").offset().top - 100
                        }, 1000);

                    }
                })
                .always(() => {
                    grecaptcha.reset();
                })
    }

})(jQuery);